const PersonMobileIcon = () => {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.6875"
        y="0.6875"
        width="42.625"
        height="42.625"
        rx="21.3125"
        stroke="#F3F3F3"
        strokeWidth="1.375"
      />
      <rect
        x="0.6875"
        y="0.6875"
        width="42.625"
        height="42.625"
        rx="21.3125"
        fill="#F3F3F3"
      />
      <rect
        x="0.6875"
        y="0.6875"
        width="42.625"
        height="42.625"
        rx="21.3125"
        stroke="#E8E9E9"
        strokeWidth="1.375"
      />
      <mask
        id="mask0_15474_61972"
        maskUnits="userSpaceOnUse"
        x="5"
        y="5"
        width="34"
        height="34"
      >
        <rect x="5.5" y="5.5" width="33" height="33" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_15474_61972)">
        <path
          d="M13.7818 29.2769C14.9505 28.4096 16.2237 27.7248 17.6014 27.2224C18.979 26.72 20.4452 26.4688 22 26.4688C23.5548 26.4688 25.021 26.72 26.3987 27.2224C27.7763 27.7248 29.0495 28.4096 30.2183 29.2769C31.0732 28.3373 31.7506 27.2497 32.2504 26.0139C32.7501 24.7782 33 23.4402 33 22C33 18.9521 31.9287 16.3567 29.786 14.214C27.6432 12.0713 25.0479 11 22 11C18.9521 11 16.3568 12.0713 14.2141 14.214C12.0714 16.3567 11 18.9521 11 22C11 23.4402 11.2499 24.7782 11.7497 26.0139C12.2494 27.2497 12.9268 28.3373 13.7818 29.2769ZM22.0004 23.0312C20.745 23.0312 19.6863 22.6003 18.8243 21.7386C17.9623 20.8768 17.5313 19.8183 17.5313 18.5629C17.5313 17.3075 17.9622 16.2488 18.8239 15.3868C19.6857 14.5248 20.7442 14.0938 21.9996 14.0938C23.255 14.0938 24.3137 14.5246 25.1757 15.3864C26.0377 16.2481 26.4687 17.3067 26.4687 18.5621C26.4687 19.8175 26.0379 20.8762 25.1761 21.7382C24.3144 22.6002 23.2558 23.0312 22.0004 23.0312ZM22 35.0624C20.1861 35.0624 18.4845 34.7213 16.8954 34.0391C15.3062 33.3569 13.9237 32.4279 12.7479 31.2521C11.5721 30.0763 10.6431 28.6938 9.96089 27.1046C9.27866 25.5155 8.93755 23.8139 8.93755 22C8.93755 20.186 9.27866 18.4845 9.96089 16.8953C10.6431 15.3061 11.5721 13.9236 12.7479 12.7478C13.9237 11.572 15.3062 10.6431 16.8954 9.96084C18.4845 9.27862 20.1861 8.9375 22 8.9375C23.814 8.9375 25.5155 9.27862 27.1047 9.96084C28.6938 10.6431 30.0763 11.572 31.2521 12.7478C32.4279 13.9236 33.3569 15.3061 34.0391 16.8953C34.7214 18.4845 35.0625 20.186 35.0625 22C35.0625 23.8139 34.7214 25.5155 34.0391 27.1046C33.3569 28.6938 32.4279 30.0763 31.2521 31.2521C30.0763 32.4279 28.6938 33.3569 27.1047 34.0391C25.5155 34.7213 23.814 35.0624 22 35.0624ZM22 33C23.241 33 24.4376 32.8003 25.5896 32.4011C26.7416 32.0018 27.7645 31.4434 28.6582 30.7259C27.7645 30.0349 26.7548 29.4964 25.6292 29.1103C24.5037 28.7242 23.2939 28.5312 22 28.5312C20.7061 28.5312 19.4941 28.722 18.3642 29.1037C17.2342 29.4853 16.2267 30.0261 15.3418 30.7259C16.2356 31.4434 17.2585 32.0018 18.4105 32.4011C19.5625 32.8003 20.759 33 22 33ZM22 20.9688C22.684 20.9688 23.256 20.7387 23.7162 20.2786C24.1762 19.8185 24.4063 19.2464 24.4063 18.5625C24.4063 17.8785 24.1762 17.3064 23.7162 16.8463C23.256 16.3862 22.684 16.1562 22 16.1562C21.316 16.1562 20.744 16.3862 20.2839 16.8463C19.8238 17.3064 19.5937 17.8785 19.5937 18.5625C19.5937 19.2464 19.8238 19.8185 20.2839 20.2786C20.744 20.7387 21.316 20.9688 22 20.9688Z"
          fill="#323941"
        />
      </g>
    </svg>
  );
};
export default PersonMobileIcon;
